import { createActions } from '@/utils/actions';

const { actions: shops } = createActions('shops')
  .addAsync('createVelaOnlyShop')
  .addAsync('getActiveListingsCount')
  .addAsync('getShopCredits')
  .addAsync('getShops')
  .addAsync('getScheduled')
  .addAsync('refreshUserInitiatedShop')
  .addAsync('refreshUserShop')
  .add('resetPublicError')
  .add('rescheduleShopsPolling')
  .add('setData')
  .add('showSyncModal')
  .addAsync('validateOauthToken');

export default shops;
